import { createSelector } from 'reselect';
import intersection from 'lodash/intersection';
import { componentsListSelector } from 'app/RenderingEnvironment/selectors';
import { permittedComponentsEditSelector } from 'app/UserInfo/selectors';

export default createSelector(
  componentsListSelector,
  permittedComponentsEditSelector,
  (componentsList, permittedComponents) =>
    permittedComponents.includes('*')
      ? componentsList
      : intersection(componentsList, permittedComponents)
);
